import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  list: [],
  employee: null,
  setting: [],
  error: "",
  loading: false,
};

export const addCompanyBasicDetailsSetup = createAsyncThunk(
  "setting/addCompanyBasicDetailsSetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `company/CompanyBasicDetailsSetup`,
        data: {
          ...values,
        },
      });
      toast.success("setting Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding setting try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const CompanyRegistrationDetailsSetup = createAsyncThunk(
  "setting/CompanyRegistrationDetailsSetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `company/CompanyRegistrationDetailsSetup`,
        data: {
          ...values,
        },
      });
      toast.success("setting Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding setting try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const CompanyBankDetailsSetup = createAsyncThunk(
  "setting/CompanyBankDetailsSetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `company/CompanyBankDetailsSetup`,
        data: {
          ...values,
        },
      });
      toast.success("setting Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding setting try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const CompanyOtherDetailsSetup = createAsyncThunk(
  "setting/CompanyOtherDetailsSetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `company/CompanyOtherDetailsSetup`,
        data: {
          ...values,
        },
      });
      toast.success("setting Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding setting try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const CompanyOfficeDetailsSetup = createAsyncThunk(
  "setting/CompanyOfficeDetailsSetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `company/CompanyOfficeDetailsSetup`,
        data: {
          ...values,
        },
      });
      toast.success("setting Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding setting try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const CompanyOfficeAreaSetup = createAsyncThunk(
  "setting/CompanyOfficeAreaSetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `company/CompanyOfficeAreaSetup`,
        data: {
          ...values,
        },
      });
      toast.success("setting Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding setting try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);
// DELETE_DESIGNATION
export const deleteSetting = createAsyncThunk(
  "setting/deleteSetting",
  async (id) => {
    try {
      const resp = await axios({
        method: "patch",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `setting/${id}`,
        data: {
          status: false,
        },
      });

      return resp.data.id;
    } catch (error) {
      // console.log(error.message);
    }
  }
);

// DESIGNATION_DETAILS
export const loadSingleSetting = createAsyncThunk(
  "setting/loadSingleSetting",
  async (id) => {
    try {
      const data = await axios.get(`setting/employee/${id}`);
      return data;
    } catch (error) {
      // console.log(error.message);
    }
  }
);

// DESIGNATIONS
export const CompanyDetailsGetbyId = createAsyncThunk(
  "setting/CompanyDetailsGetbyId",
  async (companyId, { rejectWithValue }) => {
    try {
      const url = companyId
        ? `company/CompanyDetailsGetbyId?CompanyId=${companyId}`
        : `company/CompanyDetailsGetbyId`;

      const { data } = await axios.get(url);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const CompanyOfficeDetailsGetbyCompanyId = createAsyncThunk(
  "setting/CompanyOfficeDetailsGetbyCompanyId",
  async (CompanyId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `company/CompanyOfficeDetailsGetbyCompanyId`
      );
      return data;
    } catch (error) {
      // console.error(error.message);
      return rejectWithValue(error.message);
    }
  }
);

export const CompanyOfficeDetailsGetbyOfficeId = createAsyncThunk(
  "setting/CompanyOfficeDetailsGetbyOfficeId",
  async (CompanyOfficeId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `company/CompanyOfficeDetailsGetbyId?CompanyOfficeId=${CompanyOfficeId}`
      );
      return data;
    } catch (error) {
      // console.error(error.message);
      return rejectWithValue(error.message);
    }
  }
);

export const CompanyDetailsGetbyClient = createAsyncThunk(
  "setting/CompanyDetailsGetbyClient",
  async () => {
    try {
      const { data } = await axios.get(`company/CompanyDetailsGetbyClient`);

      return data;
    } catch (error) {
      // console.log(error.message);
    }
  }
);

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    clearSettingSlice: (state) => {
      state.setting = null;
    },
  },
  extraReducers: (builder) => {
    // 1) ====== builders for CompanyDetailsGetbyId ======

    builder.addCase(CompanyDetailsGetbyId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(CompanyDetailsGetbyId.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    });

    builder.addCase(CompanyDetailsGetbyId.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 1) ====== builders for CompanyOfficeDetailsGetbyCompanyId ======

    builder.addCase(CompanyOfficeDetailsGetbyCompanyId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      CompanyOfficeDetailsGetbyCompanyId.fulfilled,
      (state, action) => {
        state.loading = false;
        state.companyOfficeDetail = action.payload;
      }
    );

    builder.addCase(
      CompanyOfficeDetailsGetbyCompanyId.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      }
    );

    // 1) ====== builders for CompanyOfficeDetailsGetbyOfficeId ======

    builder.addCase(CompanyOfficeDetailsGetbyOfficeId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      CompanyOfficeDetailsGetbyOfficeId.fulfilled,
      (state, action) => {
        state.loading = false;
        state.OfficeDetail = action.payload;
      }
    );

    builder.addCase(
      CompanyOfficeDetailsGetbyOfficeId.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      }
    );

    // 2) ====== builders for CompanyDetailsGetbyClient ======

    builder.addCase(CompanyDetailsGetbyClient.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(CompanyDetailsGetbyClient.fulfilled, (state, action) => {
      state.loading = false;
      state.clientCompanyData = action.payload;
    });

    builder.addCase(CompanyDetailsGetbyClient.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2) ====== builders for addCompanyBasicDetailsSetup ======

    builder.addCase(addCompanyBasicDetailsSetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addCompanyBasicDetailsSetup.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addCompanyBasicDetailsSetup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
    // 2) ====== builders for CompanyRegistrationDetailsSetup ======

    builder.addCase(CompanyRegistrationDetailsSetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      CompanyRegistrationDetailsSetup.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    );

    builder.addCase(
      CompanyRegistrationDetailsSetup.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      }
    );

    // 2) ====== builders for CompanyOtherDetailsSetup ======

    builder.addCase(CompanyOtherDetailsSetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(CompanyOtherDetailsSetup.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(CompanyOtherDetailsSetup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2) ====== builders for CompanyOfficeDetailsSetup ======

    builder.addCase(CompanyOfficeDetailsSetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(CompanyOfficeDetailsSetup.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(CompanyOfficeDetailsSetup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
    // 2) ====== builders for CompanyOfficeAreaSetup ======

    builder.addCase(CompanyOfficeAreaSetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(CompanyOfficeAreaSetup.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(CompanyOfficeAreaSetup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
    // 2) ====== builders for CompanyBankDetailsSetup ======

    builder.addCase(CompanyBankDetailsSetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(CompanyBankDetailsSetup.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(CompanyBankDetailsSetup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 3) ====== builders for loadSingleSetting ======

    builder.addCase(loadSingleSetting.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadSingleSetting.fulfilled, (state, action) => {
      state.loading = false;
      state.setting = action.payload.data;
    });

    builder.addCase(loadSingleSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for deleteSetting ======

    builder.addCase(deleteSetting.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(deleteSetting.fulfilled, (state, action) => {
      state.loading = false;
      const filterCategory = state.list.filter(
        (category) => category.id !== parseInt(action.payload) && category
      );
      state.list = filterCategory;

      const filterSetting = state.list.filter(
        (setting) => setting.id !== parseInt(action.payload) && setting
      );

      state.list = filterSetting;
    });

    builder.addCase(deleteSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

export default settingSlice.reducer;
export const { clearSettingSlice } = settingSlice.actions;
